import { render, staticRenderFns } from "./PricesExportPopup.vue?vue&type=template&id=b9cf434c&"
import script from "./PricesExportPopup.vue?vue&type=script&lang=js&"
export * from "./PricesExportPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports